import * as React from "react";
import { SVGProps } from "react";
function SvgMeetingStopRecIconModal(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 8h16v16H8V8Z" fill="#000" />
    </svg>
  );
}
export default SvgMeetingStopRecIconModal;
